import t from 'tcomb';
import jsdk from '../../jsdk';
import Str_Schema from '../../web/domain/Str_Schema';

const Select_Input = t.struct({
  id: t.Str,
  options: t.list(t.tuple([t.Str, t.Str])),
  schema: Str_Schema,
  attrs: t.maybe(t.Obj),
  hint: t.maybe(t.Str)
}, 'Select_Input');
/*
function Select_Input(id, options, schema, attrs, hint) {
  assert(Str.is(id));
  assert(List(Str_Option).is(options));
  assert(Str_Schema.is(schema));
  assert(Maybe(Obj).is(attrs));
  assert(Maybe(Str).is(hint));
  this.type = 'select';
  this.id = id;
  this.options = options;
  this.schema = schema;
  this.attrs = attrs;
  this.hint = hint;
  return freeze(this);
}

Select_Input.is = function(x) {
  return x instanceof Select_Input;
};

Select_Input.of = function(x) {
  assert(Obj.is(x));
  return new Select_Input(
    Str.of(x.id),
    List(Str_Option).of(x.options),
    Str_Schema.of(x.schema),
    Maybe(Obj).of(x.attrs),
    Maybe(Str).of(x.hint)
  );
};
*/
Select_Input.prototype.to_html = function(value) {
  //t.assert(t.maybe(JSON_Value).is(value));
  //t.assert(Locale.is(locale));
  var id = this.id;
  var options = [jsdk.EMPTY_OPTION].concat(this.options);
  var attrs = !t.Nil.is(this.attrs) ? jsdk.copy(this.attrs) : {};
  attrs.id = id;
  var styles = jsdk.split_margins(attrs.style);
  attrs.style = styles.other;
  return jsdk.Form.wrap_input(id, jsdk.dom.select_of_options(options, attrs, value), styles.margins, this.hint);
};

Select_Input.prototype.focus = function() {
  $('#' + this.id).focus();
};

Select_Input.prototype.set_error = function(message) {
  $("#" + this.id + "_error").html(message);
};

Select_Input.prototype.value = function(locale) {
  //t.assert(Locale.is(locale));
  var value = $('#' + this.id).val();
  var validation = this.schema.validate(value, locale);
  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
  return validation;
};

jsdk.Form.add_input('select', Select_Input);

export default Select_Input;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/form/base/Select_Input.js
 **/